import React, { FunctionComponent } from "react"
import {
    BottomNavigation,
    BottomNavigationAction,
    Grid,
    Paper,
    Typography
} from "@material-ui/core"
import { ContactsSharp as ContactUsIcon } from "@material-ui/icons"
import { useHistory } from "react-router"
import styles from "./BottomBar.module.scss"
import logo from "./versay-logo.png"

const navigationComponents = [
    {
        label: "Contact Us",
        icon: <ContactUsIcon />,
        route: "/contact",
        id: "contact-us-btn"
    }
]

export const BottomBar: FunctionComponent = () => {
    const history = useHistory()
    const onBrowserNavigation = (event: any, value: any) => {
        const component = navigationComponents[value]
        history.push(component.route)
    }

    return (
        <footer>
            <Paper variant={"outlined"} className={styles.BottomBar}>
                <Grid container>
                    <Grid item xs={4} />
                    <Grid item xs={4}>
                        <Typography
                            className={styles.BottomBar__poweredBy}
                            display={"block"}
                            variant={"body2"}
                        >
                            Powered by{" "}
                            <img className={styles.BottomBar__poweredByLogo} src={logo} />
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <BottomNavigation
                            showLabels
                            onChange={onBrowserNavigation}
                            className={styles.BottomBar__navigation}
                        >
                            {navigationComponents.map(component => {
                                return (
                                    <BottomNavigationAction
                                        key={component.label}
                                        label={component.label}
                                        icon={component.icon}
                                        id={component.id}
                                    />
                                )
                            })}
                        </BottomNavigation>
                    </Grid>
                </Grid>
            </Paper>
        </footer>
    )
}
